import React from 'react';
import {observer} from 'mobx-react';
import GoalSubnav from 'performance_goals/GoalSubnav';
import {endpoints, types, t} from 'shared/core';
import {InteractiveTable, Layout, EmployeeNameWithAvatar, HelperPanel} from 'components';
import {Employee} from 'stores/employees';

const COLUMNS = [
  {
    header: 'time_off.account_summaries.Name',
    render: model => <EmployeeNameWithAvatar employee={model}/>,
    width: 6,
    sortBy: 'name'
  },
  {
    header: 'goals.Current goals',
    render: model => <div>{model.goals.length}</div>,
    width: 6,
    sortBy: 'goals'
  }
];

const LINKS = [
  { 
    translations: {
      en: 'http://support.collage.co/en/articles/3117448-creating-a-goal'
    },
    title: 'goals.Creating a Goal'
  },
  { 
    translations: {
      en: 'http://support.collage.co/en/articles/3117451-updating-an-employee-s-progress-towards-a-goal'
    },
    title: "goals.Updating an employee's progress towards a Goal"
  },
  { 
    translations: {
      en: 'http://support.collage.co/en/articles/3117452-filtering-and-reporting-on-goals'
    },
    title: 'goals.Filtering and reporting on Goals'
  },
  {
    translations: {
      en: 'http://support.collage.co/en/articles/3131019-permissions-for-goals'
    },
    title: 'goals.Permissions for Goals'
  }
];

const GoalDirectory = observer(({scope}) => {
  return (
    <div>
      <GoalSubnav scope={scope} />
      <Layout>
        <Layout.Section>
          <InteractiveTable
            columns={COLUMNS}
            showLinks={false}
            showRoute='/employees/:id'
            proxy={{
              type: 'async',
              modelType: types.PERFORMANCE_GOALS.EMPLOYEE_DIRECTORY,
              model: Employee,
              endpoint: endpoints.PERFORMANCE_GOALS.EMPLOYEE_DIRECTORY
            }}
          />
        </Layout.Section>
        <Layout.Section secondary>
          <HelperPanel
            title={t('goals.What are performance goals?')}
            descriptionItems={[t('goals.HELP_DESCRIPTION')]}
            links={LINKS}
          />
        </Layout.Section>
      </Layout>
    </div>
  );
});

export default GoalDirectory;
